import { useStoreLogger } from '@/logger.ts'
import type { iCheckoutPaymentViewModel } from '@/components/Controls/AoePaymentControl.vue'
import type { IAoeCart } from '@/types/CartTypes'
import type { ComposerTranslation } from 'vue-i18n'

// Define the control folder name constant for OPA bank payments
export const BankPaymentControlFolderName = 'OPA'

/**
 * Sets up the Bank Payment gateway
 * @param t Translation function
 * @param cart The current cart
 * @param viewModels Available payment method view models
 */
export async function SetupBankPayment(
  t: ComposerTranslation,
  cart: IAoeCart,
  viewModels: iCheckoutPaymentViewModel[],
): Promise<void> {
  const logger = useStoreLogger()
  
  // Find the bank payment method in the view models
  const bankPaymentMethod = viewModels.find(
    vm => vm.controlFolderName === BankPaymentControlFolderName,
  )
  
  if (bankPaymentMethod == null) {
    logger.debug('SetupBankPayment', 'Bank payment method not found in available payment methods')
    return
  }
  
  logger.debug('SetupBankPayment', 'Bank payment method found:', bankPaymentMethod)
  
  // No additional setup needed for bank payments as we'll fetch the data
  // directly in the component using the PwsBeeBankingGetList API
}
